/* Pure Cartel — global site behavior (nav drawer, active link, cart badge) */
(function () {
  "use strict";

  window.PureCartel = window.PureCartel || {};

  /* ---------- cart badge ---------- */
  function updateCartBadge(count) {
    document.querySelectorAll(".cart-count").forEach(function (el) {
      el.textContent = count;
    });
  }
  window.PureCartel.updateCartBadge = updateCartBadge;
  window.PureCartel.refreshCart = function () {
    return fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartBadge(cart.item_count);
        return cart;
      });
  };

  /* ---------- mobile nav drawer ---------- */
  (function () {
    var drawer = document.getElementById("navDrawer");
    if (!drawer) return;
    var openBtn = document.getElementById("menuOpen");
    var closeBtn = document.getElementById("menuClose");

    function openMenu() {
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      if (openBtn) openBtn.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
    }
    function closeMenu() {
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      if (openBtn) openBtn.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
    }

    if (openBtn) openBtn.addEventListener("click", openMenu);
    if (closeBtn) closeBtn.addEventListener("click", closeMenu);
    drawer.querySelectorAll("[data-navclose]").forEach(function (el) {
      el.addEventListener("click", closeMenu);
    });
    drawer.querySelectorAll(".navdrawer__links a").forEach(function (a) {
      a.addEventListener("click", closeMenu);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("is-open")) closeMenu();
    });
  })();

  /* ---------- highlight the current page in the header nav ---------- */
  (function () {
    var current = location.pathname.replace(/\/$/, "") || "/";
    var links = document.querySelectorAll(".header__nav--links a");
    for (var i = 0; i < links.length; i++) {
      var href = (links[i].getAttribute("href") || "").split("#")[0].replace(/\/$/, "");
      if (href === current) { links[i].classList.add("is-current"); break; }
    }
  })();
})();
